import { ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
  children: ReactElement;
  allowedRoles?: string[];
  allowedUsers?: string[];
}

export default function ProtectedRoute({
  children,
  allowedRoles,
  allowedUsers,
}: ProtectedRouteProps) {
  const location = useLocation();

  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const fallbackPath =
    userRole === "customer_care" ? "/customer-care" : "/overview";

  if (allowedRoles && allowedRoles.length > 0) {
    if (!userRole || !allowedRoles.includes(userRole)) {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  if (allowedUsers && allowedUsers.length > 0) {
    if (!userId || !allowedUsers.includes(userId)) {
      return <Navigate to={fallbackPath} replace />;
    }
  }

  return children;
}
